// src/components/documents/lineItemStyles.js — linetext-4d8b2e61 (Stage 2, round 2: the PDF layout on screen)
//
// THE look of a line item's text on every screen that lists lines (staff estimate and invoice views, job quick
// view, the customer portal's estimate and invoice, the job profitability report), matched to the estimate /
// invoice PDF: the item NAME in bold with its DESCRIPTION directly underneath in the same column, in smaller grey
// text (the PDF: name 14px bold, description 13px #6c757d, 0 gap), top-aligned with quantity, price and total.
// Marcus, 2026-10-29: "the PDF is the reference". src/utils/lineDescriptionGuard.test.js checks every one of those
// screens uses these.

/** The item name: 14px bold (the PDF's), the screen's normal text colour. */
export const LINE_NAME = 'text-sm font-semibold text-gray-900';
/** The description, directly under the name: 13px, the PDF's grey, normal weight (a bold name cell never leaks into it). */
export const LINE_DESC = 'block mt-0.5 text-[13px] leading-snug font-normal text-[#6c757d]';
/** A quantity / price / total cell beside them: top-aligned, never wrapped (so a phone squeezes the text column, not the numbers). */
export const LINE_NUM = 'align-top whitespace-nowrap text-sm';
